import type { ButtonProps } from "react-native-paper";
import type { IconType } from "../../icon";
import Button from "../Button";

type Props = {
	fullWidth?: boolean;
	testID?: string;
} & ButtonProps;
const AuthButton = ({
	onPress,
	children,
	mode = "contained",
	disabled,
	icon,
	loading,
	fullWidth,
	testID,
}: Props) => (
	<Button
		mode={mode}
		onPress={onPress}
		disabled={disabled}
		style={fullWidth ? { width: "100%", maxWidth: 500 } : undefined}
		icon={icon as IconType}
		loading={loading}
		testID={testID}
	>
		{children || "Continue"}
	</Button>
);

export default AuthButton;
